import { Flex, Box, Stack, Center } from "@chakra-ui/react";
import { FormContainer } from "./styles";
import { useTranslation } from "react-i18next";
import { ROUTE_NAMES } from "@root/constants";
import { useNavigate } from "react-router-dom";
import { GreenTickIcon } from "@root/assets/icons/greenTickIcon";

import {
  AuthHeading,
  AuthSubheading,
  AuthButton,
} from "@root/commonStyles/commonStyle";

export const AllSet: React.FC = () => {
  const { t } = useTranslation("common");
  const navigate = useNavigate();
  return (
    <Flex minHeight="100vh" alignItems="center" justifyContent="center">
      <Stack justifyContent="center">
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          gap="16px"
          width="100%"
          maxWidth="400px" // Add this line
        >
          <GreenTickIcon />
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            gap="8px"
            width="100%"
          >
            <AuthHeading>{t("allSet.title")}</AuthHeading>
            <AuthSubheading fontSize="18px" fontWeight={400} color="#2F2F34">
              {t("allSet.subTitle")}
            </AuthSubheading>
            <AuthSubheading
              mt="16px"
              width="100%"
              textAlign="center"
              whiteSpace="normal" // Ensure wrapping
            >
              {t("allSet.subTitle2")}
            </AuthSubheading>
          </Box>
        </Box>

        <Flex alignItems="center" width="100%" maxWidth="400px">
          <AuthButton
            onClick={() => navigate(ROUTE_NAMES.LOGIN)}
            type="submit"
            width="100%"
          >
            {t("allSet.login")}
          </AuthButton>
        </Flex>
      </Stack>
    </Flex>
  );
};
